export default __webpack_public_path__ + "static/media/secure-payment.5eaf46a7.svg";